<template>
  <div
    class="eventComp_mode_4 eventComp_mode_container"
    v-show="currThemeObj"
    :class="
      notJumpDetailPage.includes(sportCompetitionType)
        ? 'notJumpDetailPageClass'
        : ''
    "
  >
    <template v-if="tableData && tableData.length > 0">
      <span
        class="half_table_group"
        v-for="group in tableData"
        :key="group.type"
      >
        <span class="table_title" :class="group.type">
          <template v-if="group.type === 'home'">
            <span
              class="teamName"
              v-text="group.team_name"
              @click="goDetail('CSMeetDelegationDetailIndex', group)"
            ></span>
            <span class="teamLogo" :class="group.team_logo ? 'isLogo' : ''">
              <img v-if="group.team_logo" :src="group.team_logo" />
            </span>
          </template>
          <template v-if="group.type === 'away'">
            <span class="teamLogo" :class="group.team_logo ? 'isLogo' : ''">
              <img v-if="group.team_logo" :src="group.team_logo" />
            </span>
            <span
              class="teamName"
              v-text="group.team_name"
              @click="goDetail('CSMeetDelegationDetailIndex', group)"
            ></span>
          </template>
          <!-- 分享按钮  -->
          <!-- <span
            v-show="isShowPublishBtn"
            class="publishBtn publishBtn_single"
            @click="clickPublicTheme(themeItem)"
          >
            <svg
              t="1692698307306"
              class="publishBtn_icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="9670"
              width="50%"
              height="50%"
            >
              <path
                d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
                p-id="9671"
              ></path>
            </svg>
          </span> -->
        </span>
        <span
          class="table_main"
          :class="[group.type, isMaxType === group.type ? 'isMax' : '']"
        >
          <span class="customTable">
            <template v-if="currModeName === 'column1-playerInfor'">
              <span
                class="customTable_row"
                :class="currModeName"
                v-for="rowItem in group.list"
                :key="rowItem.player_id"
              >
                <span
                  class="playerName-playerLogo-playerGender-teamLogo-teamName"
                >
                  <span
                    class="playerLogo"
                    :class="[
                      rowItem['player_logo'] ? 'isLogo' : '',
                      rowItem['player_gender'],
                    ]"
                  >
                    <img
                      v-if="rowItem['player_logo']"
                      :src="rowItem['player_logo']"
                    />
                  </span>
                  <span class="playerOther">
                    <span class="teamInfor">
                      <span
                        class="teamLogo"
                        :class="rowItem['team_logo'] ? 'isLogo' : ''"
                      >
                        <img
                          v-if="rowItem['team_logo']"
                          :src="rowItem['team_logo']"
                        />
                      </span>
                      <span
                        class="teamName"
                        v-text="_valPerFormatHandler(rowItem['team_name'])"
                      ></span>
                    </span>
                    <span
                      class="playerName"
                      v-text="_valPerFormatHandler(rowItem['player_name'])"
                      @click="goDetail('CSMeetPlayerDetailIndex', rowItem)"
                    ></span>
                  </span>
                </span>
              </span>
            </template>
            <template v-if="currModeName === 'column2-playerInfor-birthDate'">
              <span
                class="customTable_row"
                :class="currModeName"
                v-for="rowItem in group.list"
                :key="rowItem.player_id"
              >
                <span
                  class="playerName-playerLogo-playerGender-teamLogo-teamName"
                >
                  <span
                    class="playerLogo"
                    :class="[
                      rowItem['player_logo'] ? 'isLogo' : '',
                      rowItem['player_gender'],
                    ]"
                  >
                    <img
                      v-if="rowItem['player_logo']"
                      :src="rowItem['player_logo']"
                    />
                  </span>
                  <span class="playerOther">
                    <span class="teamInfor">
                      <span
                        class="teamLogo"
                        :class="rowItem['team_logo'] ? 'isLogo' : ''"
                      >
                        <img
                          v-if="rowItem['team_logo']"
                          :src="rowItem['team_logo']"
                        />
                      </span>
                      <span
                        class="teamName"
                        v-text="_valPerFormatHandler(rowItem['team_name'])"
                      ></span>
                    </span>
                    <span
                      class="playerName"
                      v-text="_valPerFormatHandler(rowItem['player_name'])"
                      @click="goDetail('CSMeetPlayerDetailIndex', rowItem)"
                    ></span>
                  </span>
                </span>
                <span
                  class="player_birthDate"
                  v-text="_valPerFormatHandler(rowItem['birth_date'])"
                ></span>
              </span>
            </template>

            <template
              v-else-if="currModeName === 'column2-playerInfor-playerNO'"
            >
              <span
                class="customTable_row"
                :class="currModeName"
                v-for="rowItem in group.list"
                :key="rowItem.player_id"
              >
                <span
                  class="playerName-playerLogo-playerGender-teamLogo-teamName"
                >
                  <span
                    class="playerLogo"
                    :class="[
                      rowItem['player_logo'] ? 'isLogo' : '',
                      rowItem['player_gender'],
                    ]"
                  >
                    <img
                      v-if="rowItem['player_logo']"
                      :src="rowItem['player_logo']"
                    />
                  </span>
                  <span class="playerOther">
                    <span class="teamInfor">
                      <span
                        class="teamLogo"
                        :class="rowItem['team_logo'] ? 'isLogo' : ''"
                      >
                        <img
                          v-if="rowItem['team_logo']"
                          :src="rowItem['team_logo']"
                        />
                      </span>
                      <span
                        class="teamName"
                        v-text="_valPerFormatHandler(rowItem['team_name'])"
                      ></span>
                    </span>
                    <span
                      class="playerName"
                      v-text="_valPerFormatHandler(rowItem['player_name'])"
                      @click="goDetail('CSMeetPlayerDetailIndex', rowItem)"
                    ></span>
                  </span>
                </span>
                <span
                  class="player_number"
                  v-text="_valPerFormatHandler(rowItem.bib_number)"
                ></span>
              </span>
            </template>
            <template v-else-if="currModeName === 'column3-playerInfor'">
              <span
                class="customTable_row"
                :class="currModeName"
                v-for="rowItem in group.list"
                :key="rowItem.player_id"
              >
                <span
                  class="playerName-playerLogo-playerGender-teamLogo-teamName"
                >
                  <span
                    class="playerLogo"
                    :class="[
                      rowItem['player_logo'] ? 'isLogo' : '',
                      rowItem['player_gender'],
                    ]"
                  >
                    <img
                      v-if="rowItem['player_logo']"
                      :src="rowItem['player_logo']"
                    />
                  </span>
                  <span class="playerOther">
                    <span class="teamInfor">
                      <span
                        class="teamLogo"
                        :class="rowItem['team_logo'] ? 'isLogo' : ''"
                      >
                        <img
                          v-if="rowItem['team_logo']"
                          :src="rowItem['team_logo']"
                        />
                      </span>
                      <span
                        class="teamName"
                        v-text="_valPerFormatHandler(rowItem['team_name'])"
                      ></span>
                    </span>
                    <span
                      class="playerName"
                      v-text="_valPerFormatHandler(rowItem['player_name'])"
                      @click="goDetail('CSMeetPlayerDetailIndex', rowItem)"
                    ></span>
                  </span>
                </span>
                <span
                  class="player_number"
                  v-text="_valPerFormatHandler(rowItem.bib_number)"
                ></span>
                <span
                  class="player_state"
                  v-text="formatStarterText(rowItem.is_starter)"
                ></span>
              </span>
            </template>
            <template
              v-else-if="currModeName === 'column3-playerInfor-birthDate'"
            >
              <span
                class="customTable_row"
                :class="currModeName"
                v-for="rowItem in group.list"
                :key="rowItem.player_id"
              >
                <span
                  class="playerName-playerLogo-playerGender-teamLogo-teamName"
                >
                  <span
                    class="playerLogo"
                    :class="[
                      rowItem['player_logo'] ? 'isLogo' : '',
                      rowItem['player_gender'],
                    ]"
                  >
                    <img
                      v-if="rowItem['player_logo']"
                      :src="rowItem['player_logo']"
                    />
                  </span>
                  <span class="playerOther">
                    <span class="teamInfor">
                      <span
                        class="teamLogo"
                        :class="rowItem['team_logo'] ? 'isLogo' : ''"
                      >
                        <img
                          v-if="rowItem['team_logo']"
                          :src="rowItem['team_logo']"
                        />
                      </span>
                      <span
                        class="teamName"
                        v-text="_valPerFormatHandler(rowItem['team_name'])"
                      ></span>
                    </span>
                    <span
                      class="playerName"
                      v-text="_valPerFormatHandler(rowItem['player_name'])"
                      @click="goDetail('CSMeetPlayerDetailIndex', rowItem)"
                    ></span>
                  </span>
                </span>
                <span
                  class="player_number"
                  v-text="_valPerFormatHandler(rowItem.bib_number)"
                ></span>
                <span
                  class="player_birthDate"
                  v-text="_valPerFormatHandler(rowItem['birth_date'])"
                ></span>
              </span>
            </template>
            <template v-else-if="currModeName === 'column1-playerInfor-color'">
              <span
                class="customTable_row"
                :class="currModeName"
                v-for="rowItem in group.list"
                :key="rowItem.player_id"
              >
                <span
                  class="playerName-playerLogo-playerGender-teamLogo-teamName"
                >
                  <span
                    class="playerLogo"
                    :class="[
                      rowItem['player_logo'] ? 'isLogo' : '',
                      rowItem['player_gender'],
                    ]"
                  >
                    <img
                      v-if="rowItem['player_logo']"
                      :src="rowItem['player_logo']"
                    />
                  </span>
                  <span class="playerOther">
                    <span class="teamInfor">
                      <span
                        class="teamLogo"
                        :class="rowItem['team_logo'] ? 'isLogo' : ''"
                      >
                        <img
                          v-if="rowItem['team_logo']"
                          :src="rowItem['team_logo']"
                        />
                      </span>
                      <span
                        class="teamName"
                        v-text="_valPerFormatHandler(rowItem['team_name'])"
                      ></span>
                    </span>
                    <span
                      class="playerName"
                      v-text="_valPerFormatHandler(rowItem['player_name'])"
                      @click="goDetail('CSMeetPlayerDetailIndex', rowItem)"
                    ></span>
                  </span>
                </span>
                <span
                  class="color"
                  :style="{
                    backgroundColor: `${rowItem['clothing_color']}`,
                    borderColor: `${
                      ['WHITE', 'white'].includes(rowItem['clothing_color'])
                        ? 'GREY'
                        : rowItem['clothing_color']
                    }`,
                  }"
                ></span>
              </span>
            </template>

            <template v-else-if="currModeName === 'column2-playerInfor-num'">
              <span
                class="customTable_row"
                :class="currModeName"
                v-for="rowItem in group.list"
                :key="rowItem.player_id"
              >
                <span
                  class="playerName-playerLogo-playerGender-teamLogo-teamName"
                >
                  <span
                    class="playerLogo"
                    :class="[
                      rowItem['player_logo'] ? 'isLogo' : '',
                      rowItem['player_gender'],
                    ]"
                  >
                    <img
                      v-if="rowItem['player_logo']"
                      :src="rowItem['player_logo']"
                    />
                  </span>
                  <span class="playerOther">
                    <span class="teamInfor">
                      <span
                        class="teamLogo"
                        :class="rowItem['team_logo'] ? 'isLogo' : ''"
                      >
                        <img
                          v-if="rowItem['team_logo']"
                          :src="rowItem['team_logo']"
                        />
                      </span>
                      <span
                        class="teamName"
                        v-text="_valPerFormatHandler(rowItem['team_name'])"
                      ></span>
                    </span>
                    <span
                      class="playerName"
                      v-text="_valPerFormatHandler(rowItem['player_name'])"
                      @click="goDetail('CSMeetPlayerDetailIndex', rowItem)"
                    ></span>
                  </span>
                </span>
                <span
                  class="player_num"
                  v-text="_valPerFormatHandler(rowItem['sequence_number'])"
                ></span>
              </span>
            </template>
            <template
              v-else-if="currModeName === 'column3-playerInfor-position'"
            >
              <span
                class="customTable_row"
                :class="currModeName"
                v-for="rowItem in group.list"
                :key="rowItem.player_id"
              >
                <span
                  class="playerName-playerLogo-playerGender-teamLogo-teamName"
                >
                  <span
                    class="playerLogo"
                    :class="[
                      rowItem['player_logo'] ? 'isLogo' : '',
                      rowItem['player_gender'],
                    ]"
                  >
                    <img
                      v-if="rowItem['player_logo']"
                      :src="rowItem['player_logo']"
                    />
                  </span>
                  <span class="playerOther">
                    <span class="teamInfor">
                      <span
                        class="teamLogo"
                        :class="rowItem['team_logo'] ? 'isLogo' : ''"
                      >
                        <img
                          v-if="rowItem['team_logo']"
                          :src="rowItem['team_logo']"
                        />
                      </span>
                      <span
                        class="teamName"
                        v-text="_valPerFormatHandler(rowItem['team_name'])"
                      ></span>
                    </span>
                    <span
                      class="playerName"
                      v-text="_valPerFormatHandler(rowItem['player_name'])"
                      @click="goDetail('CSMeetPlayerDetailIndex', rowItem)"
                    ></span>
                  </span>
                </span>
                <span
                  class="player_number"
                  :class="rowItem.is_coach ? 'hide' : ''"
                  v-text="_valPerFormatHandler(rowItem.bib_number)"
                ></span>
                <span
                  class="player_state"
                  v-text="
                    rowItem.is_coach
                      ? '教练'
                      : rowItem.position
                      ? rowItem.position
                      : ''
                  "
                ></span>
              </span>
            </template>
            <template
              v-else-if="
                [
                  'column4-playerInfor-position-isStart',
                  'column3-playerInfor-position-isStart',
                ].includes(currModeName)
              "
            >
              <span
                class="customTable_row"
                :class="currModeName"
                v-for="rowItem in group.list"
                :key="rowItem.player_id"
              >
                <span
                  class="playerName-playerLogo-playerGender-teamLogo-teamName"
                >
                  <span
                    class="playerLogo"
                    :class="[
                      rowItem['player_logo'] ? 'isLogo' : '',
                      rowItem['player_gender'],
                    ]"
                  >
                    <img
                      v-if="rowItem['player_logo']"
                      :src="rowItem['player_logo']"
                    />
                  </span>
                  <span class="playerOther">
                    <span class="teamInfor">
                      <span
                        class="teamLogo"
                        :class="rowItem['team_logo'] ? 'isLogo' : ''"
                      >
                        <img
                          v-if="rowItem['team_logo']"
                          :src="rowItem['team_logo']"
                        />
                      </span>
                      <span
                        class="teamName"
                        v-text="_valPerFormatHandler(rowItem['team_name'])"
                      ></span>
                    </span>
                    <span
                      class="playerName"
                      v-text="_valPerFormatHandler(rowItem['player_name'])"
                      @click="goDetail('CSMeetPlayerDetailIndex', rowItem)"
                    ></span>
                  </span>
                </span>
                <span
                  v-if="currModeName === 'column4-playerInfor-position-isStart'"
                  class="player_number"
                  :class="rowItem.is_coach ? 'hide' : ''"
                  v-text="_valPerFormatHandler(rowItem.bib_number)"
                ></span>
                <span
                  class="player_state"
                  v-text="
                    rowItem.is_coach
                      ? '教练'
                      : rowItem.position
                      ? rowItem.position
                      : ''
                  "
                ></span>
                <span
                  v-if="rowItem.is_starter"
                  class="start_icon"
                  v-text="'首'"
                ></span>
              </span>
            </template>
          </span>
        </span>
      </span>
    </template>
    <template v-if="themeList && themeList.length > 0">
      <span :class="themeList ? `publishBtn${themeList.length}` : ''" class="">
        <span
          class="center_btn"
          v-show="isShowPublishBtn"
          v-for="themeItem in themeList"
          :key="themeItem.analysisItemId"
        >
          <span
            class="publishBtn publishBtn_all"
            @click="clickPublicTheme(themeItem)"
          >
            <svg
              t="1692698307306"
              class="publishBtn_icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="9670"
              width="50%"
              height="50%"
            >
              <path
                d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
                p-id="9671"
              ></path>
            </svg>
          </span>
        </span>
      </span>
    </template>
  </div>
</template>

<script>
// 适用： 对抗类 展示代表团双方+各自队员
import cup_base_data_mixin from '@mixins/cup_base_data'
import single_findAnalysisItem_data_mixin from '@mixins/single_findAnalysisItem_data'
export default {
  name: 'eventComp_mode_4',
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    datas: {
      type: Object,
      default: () => ({}),
    },
    sportCompetitionType: {
      type: String, //赛事类型
      default: '',
    },
  },
  mixins: [cup_base_data_mixin, single_findAnalysisItem_data_mixin],
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug('mode_4 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.init()
        }
      },
      // immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      themeTemplateType: 17, //综合性赛事
      themeList: null,
      tableData: null,
      isMaxType: '',
      currModeName: '',
      renderModeList: [
        {
          modeName: 'column1-playerInfor',
          sportsIdArr: ['ARC', 'CLB', 'KTE', 'KAB', 'KUR'],
        },
        {
          modeName: 'column2-playerInfor-birthDate',
          sportsIdArr: ['TTE', 'BDM', 'TEN', 'TST', 'PDL', 'TEQ'],
        },
        {
          modeName: 'column2-playerInfor-playerNO',
          sportsIdArr: ['WPO', 'BK3'],
        },
        {
          modeName: 'column3-playerInfor',
          sportsIdArr: ['BKB', 'VVO'],
        },
        {
          modeName: 'column3-playerInfor-birthDate',
          sportsIdArr: [
            'VBV',
            'ELS',
            'HBL',
            'HOC',
            'BBL',
            'BOX',
            'SBL',
            'SQU',
            'RUG',
            'CKT',
            'MGO',
            'SEW',
            'SPK',
            'RU7',
            'MMA',
          ],
        },
        {
          modeName: 'column1-playerInfor-color',
          sportsIdArr: ['JUD', 'TKW'],
        },
        {
          modeName: 'column2-playerInfor-num',
          sportsIdArr: ['FEN'],
        },
        {
          modeName: 'column4-playerInfor-position-isStart',
          sportsIdArr: ['FBL', 'IHO', 'FIBAWA','FIBAMA'],
        },
        {
          modeName: 'column3-playerInfor-position',
          sportsIdArr: ['SHO'], //奥运会 射击决赛是对抗类的
        },
        {
          modeName: 'column3-playerInfor-position-isStart', //与 column4-playerInfor-position-isStart 的区别不带球衣号
          sportsIdArr: ['CUR'],
        },
      ],
    }
  },
  created() {
    if (['FIBAWA', 'FIBAMA'].includes(this.currSportsDetail.sportsId)) {
      this.themeTemplateType = 28 // 篮球杯赛 出场名单
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    isShowPublishBtn() {
      // 目前只有足球的赛果首发阵容需要
      if (
        this.currSportsDetail &&
        ['FBL', 'BKB', 'IHO', 'FIBAWA', 'FIBAMA'].includes(
          this.currSportsDetail.sportsId
        ) &&
        this.themeList &&
        this.themeList.length > 0
      ) {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    formatStarterText(isStart) {
      if (isStart === true) {
        return '首发'
      } else if (isStart === false) {
        return '替补'
      } else {
        return ''
      }
    },
    async init() {
      console.debug(
        'mode_4 ',
        this.currSportsDetail,
        this.datas,
        this.startListProp,
        this.sportsTypeArr
      )
      this.makeAnalysisItemParams(this.themeTemplateType)
      this.$nextTick(() => {
        if (this.currSportsDetail && this.currSportsDetail.sportsId) {
          this.renderModeList.forEach((modeItem) => {
            if (modeItem.sportsIdArr.includes(this.currSportsDetail.sportsId)) {
              this.currModeName = modeItem.modeName
            }
          })
        }
        this.computedModeData(JSON.parse(JSON.stringify(this.datas)))
      })
    },
    goDetail(routerName, item, id) {
      console.debug(
        routerName,
        item,
        this.sportCompetitionType,
        this.notJumpDetailPage
      )
      if (this.notJumpDetailPage.includes(this.sportCompetitionType)) return
      let query = {}
      if (routerName == 'CSMeetPlayerDetailIndex') {
        query.playerId = item ? item.player_id : id
      }
      if (routerName == 'CSMeetDelegationDetailIndex') {
        query.delegationId = item ? item.team_id : id
      }
      this.pageJump(this.$router, `${routerName}_${this.currCid}`, query)
    },
    makeAnalysisItemParams(themeTemplateType) {
      // 每个页面单独设置不同函数
      console.debug('makeAnalysisItemParams')
      // 综合性运动会 后端给的是 disciplineId ; 前端定义的是 sportsId ; 需要转一下，其他都一样
      if (['FIBAWA', 'FIBAMA'].includes(this.currSportsDetail.sportsId)) {
        this.findAnalysisItemParams = {
          sportType: 'compreSportsMeet',
          templateType: themeTemplateType,
          cid: this.currCid,
          sid: this.currSid,
          did: 0,
          eid: 0,
          pid: 0,
          mid: this.currSportsDetail.matchId,
        }
      } else {
        this.findAnalysisItemParams = {
          sportType: 'compreSportsMeet',
          templateType: themeTemplateType,
          cid: this.currCid,
          sid: this.currSid,
          did: this.currSportsDetail.sportsId,
          eid: this.currSportsDetail.eventId,
          pid: 0,
          mid: this.currSportsDetail.matchId,
        }
      }

      if (this.initSingleFindAnalysisItem) {
        this.initSingleFindAnalysisItem(this.findAnalysisItemParams)
      }
      // let { num } = this.paramsChangeObj
      // this.paramsChangeObj = {
      //   type: 'reset',
      //   num: num + 1,
      // }
    },
    findAnalysisItemCallback(resData) {
      const themeList = resData.map((item) => {
        item.actJson = JSON.parse(item.json)
        return item
      })
      if (themeList && themeList.length > 0) {
        let matchId = 0
        if (this.currSportsDetail && this.currSportsDetail.matchId) {
          matchId = this.currSportsDetail.matchId
        }
        this.themeList = themeList.map((themeItem) => {
          themeItem.sportsId = themeItem.disciplineId
            ? themeItem.disciplineId
            : 0
          themeItem.eventId = themeItem.eventId ? themeItem.eventId : 0
          themeItem.phaseId = themeItem.phaseId ? themeItem.phaseId : 0
          themeItem.matchId = matchId ? matchId : 0
          themeItem.groupType = themeItem.groupType ? themeItem.groupType : 0

          return themeItem
        })
      } else {
        this.themeList = null
      }
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
    notDataHandler() {
      this.tableData = []
    },
    computedModeData(data) {
      console.debug('computedModeData:', data)
      if (data.subList && data.subList.length > 0 && !data.home) {
        // 单独处理一下 羽毛球 团体 startList 情况，将subList变为home 和 away
        const keyArr = ['home', 'away']
        data.home = []
        data.away = []

        data.subList.forEach((group) => {
          keyArr.forEach((key) => {
            data[key] = [].concat(data[key], group[key])
          })
        })
      }
      let tableData = []
      let isMaxType = ''
      let homeNum = 0,
        awayNum = 0
      if (data.home && data.home.length > 0) {
        homeNum = data.home.length
        tableData.push({
          type: 'home',
          list: data.home,
          team_id: data.home[0].team_id,
          team_name: data.home[0].team_name,
          team_logo: data.home[0].team_logo,
        })
      } else {
        tableData.push({
          type: 'home',
          list: [],
          team_id: '',
          team_name: '',
          team_logo: '',
        })
      }
      if (data.away && data.away.length > 0) {
        awayNum = data.away.length
        tableData.push({
          type: 'away',
          list: data.away,
          team_id: data.away[0].team_id,
          team_name: data.away[0].team_name,
          team_logo: data.away[0].team_logo,
        })
      } else {
        tableData.push({
          type: 'away',
          playerList: [],
          team_id: '',
          team_name: '',
          team_logo: '',
        })
      }
      if (tableData.length > 0) {
        if (homeNum >= awayNum) {
          isMaxType = 'home'
        } else {
          isMaxType = 'away'
        }
        this.isMaxType = isMaxType
        this.tableData = tableData
      } else {
        this.notDataHandler()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.eventComp_mode_container {
  position: relative;
  padding: 1.388vw 0;
  width: 100%;
  height: auto;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: flex-start;
  .publishBtn3 {
    .center_btn {
      &:first-child {
        left: 0%;
        transform: translateX(0);
      }
    }

    .center_btn {
      &:nth-child(2) {
        left: 100%;
        transform: translateX(-100%);
      }
    }
    .center_btn {
      &:last-child {
        left: 50%;
      }
    }
  }
  .center_btn {
    position: absolute;
    left: 50%;
    top: 1.388vw;
    z-index: 2;
    width: 3.6vw;
    height: 3.125vw;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    transform: translateX(-50%);

    .publishBtn_all {
      width: 100%;
      text-align: center;
      svg.publishBtn_icon {
        fill: var(--mixtmt_whiteColor);
      }
    }
  }
  .half_table_group {
    width: 50%;
    height: auto;
    /* background-color: var(--mixtmt_greyColor8); */
    .table_title {
      position: relative;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      color: var(--mixtmt_table_headerColor);
      width: 100%;
      height: 3.125vw;
      background-color: var(--mixtmt_table_headerBg);
      .publishBtn_single {
        position: absolute;
        top: 50%;
        z-index: 2;
        width: 3.6vw;
        text-align: center;
        transform: translateY(-50%);
        svg.publishBtn_icon {
          fill: var(--mixtmt_whiteColor);
        }
      }
      &.home {
        .teamName {
          padding-right: 0.694vw;
        }
        .publishBtn_single {
          left: 0;
        }
      }
      &.away {
        .teamName {
          padding-left: 0.694vw;
        }
        .publishBtn_single {
          right: 0;
        }
      }
      .teamLogo {
        width: 2.916vw;
        height: 1.944vw;
        overflow: hidden;
        background-color: var(--mixtmt_greyColor0);
        &.isLogo {
          background-color: transparent;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .teamName {
        font-size: 1.11vw;
        font-weight: bold;
      }
    }
    .table_main {
      position: relative;
      width: 100%;
      height: auto;
      color: var(--mixtmt_greyColor3);
      &.home {
        &.isMax {
          &::before {
            content: '\20';
            position: absolute;
            top: 0;
            right: 0;
            z-index: 2;
            width: 1px;
            height: 100%;
            background-color: var(--mixtmt_greyColor7);
          }
        }
        .player_number {
          background-image: var(--mixtmt_homePlayerNo_bg);
        }
      }
      &.away {
        &.isMax {
          &::before {
            content: '\20';
            position: absolute;
            top: 0;
            left: 0;
            z-index: 2;
            width: 1px;
            height: 100%;
            background-color: var(--mixtmt_greyColor7);
          }
        }
        .player_number {
          background-image: var(--mixtmt_awayPlayerNo_bg);
        }
      }
      .customTable {
        width: 100%;
        height: auto;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
      }

      .customTable_row {
        position: relative;
        width: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        height: 5.55vw;
        padding: 0 0.694vw;
        border-bottom: 1px solid var(--mixtmt_greyColor7);
        .playerName-playerLogo-playerGender-teamLogo-teamName {
          height: 4.16vw;
          width: 25vw;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          .playerLogo {
            position: relative;
            width: 4.16vw;
            height: 4.16vw;
            border-radius: 50%;
            background-size: 100% auto;
            background-position: left 35%;
            background-repeat: no-repeat;
            background-image: var(--mixtmt_default_playerLogo);
            &::before {
              position: absolute;
              content: '\20';
              bottom: 0;
              right: 0;
              z-index: 5;
              width: 1.11vw;
              height: 1.11vw;
              background-size: 100% 100%;
              background-repeat: no-repeat;
              background-position: center;
              /* background-image: var(--mixtmt_gender_male_icon); */
            }
            &::after {
              position: absolute;
              content: '\20';
              bottom: 0;
              right: 0;
              z-index: 2;
              width: 100%;
              height: 100%;
              border-radius: 50%;
              border: 1px solid var(--mixtmt_greyColor5);
            }
            &.F {
              &::before {
                background-image: var(--mixtmt_gender_female_icon);
              }
            }
            &.M {
              &::before {
                background-image: var(--mixtmt_gender_male_icon);
              }
            }
            &.isLogo {
              background-image: none;
            }
            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 50%;
            }
          }
          .playerOther {
            width: calc(100% - 4.16vw);
            padding: 0 0.694vw;
            height: 4.16vw;
            display: flex;
            display: -webkit-flex;
            justify-content: space-between;
            align-items: flex-start;
            flex-direction: column;
            .teamInfor {
              width: 100%;
              height: 1.66vw;
              display: flex;
              display: -webkit-flex;
              justify-content: flex-start;
              align-items: center;
              .teamLogo {
                width: 2.5vw;
                height: 1.66vw;
                overflow: hidden;
                background-color: var(--mixtmt_greyColor0);
                &.isLogo {
                  background-color: transparent;
                }
                img {
                  display: block;
                  width: 100%;
                  height: 100%;
                  object-fit: contain;
                }
              }
              .teamName {
                padding-left: 0.694vw;
                font-size: 0.972vw;
                color: var(--mixtmt_greyColor2);
              }
            }
            .playerName {
              width: auto;
              max-width: 100%;
              font-size: 1.11vw;
              height: 1.38vw;
              line-height: 1.38vw;
              color: var(--mixtmt_greyColor3);
              text-align: left;
              font-weight: bold;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
        .player_number {
          margin: 0 0.694vw;
          width: 3.47vw;
          height: 2.788vw;
          background-repeat: no-repeat;
          background-position: center;
          background-size: 100% 100%;
          color: var(--mixtmt_whiteColor);
          line-height: 2.788vw;
          font-size: 1.11vw;
          text-align: center;
          &.hide {
            background-image: none !important;
          }
        }
        .player_state {
          width: 6.94vw;
          color: var(--mixtmt_greyColor2);
          font-size: 1.11vw;
          text-align: center;
        }
        .player_birthDate {
          width: 9.72vw;
          color: var(--mixtmt_greyColor2);
          font-size: 1.11vw;
          text-align: center;
        }
        .player_num {
          width: 6.94vw;
          color: var(--mixtmt_greyColor2);
          font-size: 1.11vw;
          text-align: center;
        }
        .start_icon {
          position: absolute;
          right: 0.694vw;
          top: 50%;
          z-index: 0;
          width: 1.68vw;
          height: 1.68vw;
          border-radius: 50%;
          background-color: var(--mixtmt_successColor);
          transform: translateY(-50%);
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          color: var(--mixtmt_whiteColor);
          font-size: 0.972vw;
        }
        &.column1-playerInfor {
          padding: 0 0.694vw 0 4.16vw;
          .playerName-playerLogo-playerGender-teamLogo-teamName {
            width: 100%;
          }
        }
        &.column2-playerInfor-birthDate {
          padding: 0 0 0 2.083vw;
          .playerName-playerLogo-playerGender-teamLogo-teamName {
            width: calc(100% - 9.72vw);
          }
        }

        &.column2-playerInfor-num {
          padding: 0 0 0 2.083vw;
          .playerName-playerLogo-playerGender-teamLogo-teamName {
            width: calc(100% - 6.94vw);
          }
        }

        &.column3-playerInfor {
          padding: 0 0 0 2.083vw;
          .playerName-playerLogo-playerGender-teamLogo-teamName {
            width: calc(100% - 3.47vw - 1.388vw - 6.94vw);
          }
        }
        &.column3-playerInfor-birthDate {
          padding: 0 0 0 2.083vw;
          .playerName-playerLogo-playerGender-teamLogo-teamName {
            width: calc(100% - 3.47vw - 1.388vw - 9.72vw);
          }
        }
        &.column2-playerInfor-playerNO {
          .playerName-playerLogo-playerGender-teamLogo-teamName {
            width: calc(100% - 6.94vw - 1.388vw);
          }
        }
        &.column1-playerInfor-color {
          padding: 0 2.788vw;
          .playerName-playerLogo-playerGender-teamLogo-teamName {
            width: calc(100% - 2.43vw);
          }
          .color {
            width: 2.43vw;
            height: 1.38vw;
            border-width: 1px;
            border-style: solid;
          }
        }
      }
    }
  }
}
.mixtmt_pc {
  .eventComp_mode_container {
    &.notJumpDetailPageClass {
      .half_table_group {
        *:not(.publishBtn) {
          cursor: default !important;
        }
      }
    }

    .publishBtn {
      &:hover {
        cursor: pointer;
        svg.publishBtn_icon {
          fill: var(--mixtmt_greyColor4);
        }
      }
    }
    .half_table_group {
      .table_title {
        .teamName {
          &:hover {
            cursor: pointer;
            text-decoration: underline;
          }
        }
        .publishBtn {
          &:hover {
            cursor: pointer;
            svg.publishBtn_icon {
              fill: var(--mixtmt_greyColor4);
            }
          }
        }
      }
      .table_main {
        position: relative;
        width: 100%;
        height: auto;
        color: var(--mixtmt_greyColor3);
        &.home {
          &.isMax {
            &::before {
              content: '\20';
              position: absolute;
              top: 0;
              right: 0;
              z-index: 2;
              width: 1px;
              height: 100%;
              background-color: var(--mixtmt_greyColor7);
            }
          }
          .player_number {
            background-image: var(--mixtmt_homePlayerNo_bg);
          }
        }
        &.away {
          &.isMax {
            &::before {
              content: '\20';
              position: absolute;
              top: 0;
              left: 0;
              z-index: 2;
              width: 1px;
              height: 100%;
              background-color: var(--mixtmt_greyColor7);
            }
          }
          .player_number {
            background-image: var(--mixtmt_awayPlayerNo_bg);
          }
        }
        .customTable {
          width: 100%;
          height: auto;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          flex-direction: column;
        }

        .customTable_row {
          width: 100%;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          height: 5.55vw;
          padding: 0 0.694vw;
          border-bottom: 1px solid var(--mixtmt_greyColor7);
          .playerName-playerLogo-playerGender-teamLogo-teamName {
            .playerOther {
              .playerName {
                &:hover {
                  cursor: pointer;
                  color: var(--mixtmt_subColor1_1);
                  text-decoration: underline;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
